import { MarketingAutomationConfigKeys } from "kadow-jetpack-model";
import { tt } from "../../../../../utils/i18n/i18n";

export function getDescriptorForKey(key: MarketingAutomationConfigKeys) {
  switch (key) {
    case MarketingAutomationConfigKeys.onboarding:
      return {
        key,
        name: tt("ma_welcome_email"),
        description: tt("ma_welcome_email_desc")
      };

    case MarketingAutomationConfigKeys.grant_tokens_15th:
      return {
        key,
        name: tt("ma_tokens_offered"),
        description: tt("ma_tokens_offered_desc")
      };

    case MarketingAutomationConfigKeys.birthday:
      return {
        key,
        name: tt("ma_birthday"),
        description: tt("ma_birthday_desc")
      };

    case MarketingAutomationConfigKeys.reminder:
      return {
        key,
        name: tt("ma_reminder"),
        description: tt("ma_reminder_desc")
      };

    default:
      return null;
  }
}
